import { AxiosError } from 'axios';
import { all, call, fork, put, take } from 'redux-saga/effects';
import * as actions from '../actions';
import { apiMethods } from '../services/api';
import { apiMethodsConst } from '../services/methods';

type TApiMethodKey = keyof typeof apiMethods;

function* callAndDispatch(method: TApiMethodKey, payload?: any): Generator<any, any, any> {
  const response = yield call(apiMethods[method], payload);
  yield put({ type: method, payload: response });
}

function* callAndDispatchPayload(method: TApiMethodKey, payload?: any): Generator<any, any, any> {
  yield call(apiMethods[method], payload);
  yield put({ type: method, payload });
}

function* watchFetchFavoriteProfessionals(): Generator<any, void, any> {
  const events: any = actions.createRequestTypes(actions.FETCH_FAVORITE_PROFESSIONALS);
  while (true) {
    const { jobId } = yield take(actions.FETCH_FAVORITE_PROFESSIONALS);
    const params = jobId ? { jobId } : {};
    try {
      yield put({ type: events.REQUEST });
      yield* callAndDispatch(apiMethodsConst.FETCH_FAVORITE_PROFESSIONALS_REQUEST, params);
      yield put({ type: events.SUCCESS });
    } catch (error: any) {
      yield put({ type: events.FAILURE, payload: (error as AxiosError)?.response?.data });
    }
  }
}

function* watchFetchRecentProfessionals(): Generator<any, void, any> {
  const events: any = actions.createRequestTypes(actions.FETCH_RECENT_PROFESSIONALS);
  while (true) {
    const { filter } = yield take(actions.FETCH_RECENT_PROFESSIONALS);
    yield put({ type: events.REQUEST });
    try {
      yield* callAndDispatch(apiMethodsConst.FETCH_RECENT_PROFESSIONALS_REQUEST, {
        ...(filter !== 'all' && {
          professions: filter,
        }),
      });
      yield put({ type: events.SUCCESS });
    } catch (error: any) {
      yield put({ type: events.FAILURE, payload: (error as AxiosError)?.response?.data });
    }
  }
}

function* watchFetchRecommendedProfessionals(): Generator<any, void, any> {
  const events: any = actions.createRequestTypes(actions.FETCH_RECOMMENDED_PROFESSIONALS_ACTION);
  while (true) {
    const {
      payload: { filter },
    } = yield take(actions.FETCH_RECOMMENDED_PROFESSIONALS_ACTION);

    yield put({ type: events.REQUEST });
    try {
      yield* callAndDispatch(apiMethodsConst.FETCH_RECOMMENDED_PROFESSIONALS_REQUEST, {
        ...(filter !== 'all' && {
          profession: filter,
        }),
      });
      yield put({ type: events.SUCCESS });
    } catch (error: any) {
      yield put({ type: events.FAILURE, payload: (error as AxiosError)?.response?.data });
    }
  }
}

function* watchRemoveFavoriteProfessional(): Generator<any, void, any> {
  const events: any = actions.createRequestTypes(actions.REMOVE_FAVORITE_PROFESSIONAL);
  while (true) {
    const { userId } = yield take(actions.REMOVE_FAVORITE_PROFESSIONAL);

    yield put({ type: events.REQUEST });
    try {
      yield* callAndDispatch(apiMethodsConst.DELETE_FAVORITE_PROFESSIONAL_REQUEST, userId);
      yield* callAndDispatch(apiMethodsConst.FETCH_FAVORITE_PROFESSIONALS_REQUEST);
      yield put({ type: events.SUCCESS });
    } catch (error: any) {
      yield put({ type: events.FAILURE, payload: (error as AxiosError)?.response?.data });
    }
  }
}

function* watchPatchFavoriteProfessional(): Generator<any, void, any> {
  const events: any = actions.createRequestTypes(actions.ADD_FAVORITE_PROFESSIONAL);
  while (true) {
    const { userId } = yield take(actions.ADD_FAVORITE_PROFESSIONAL);

    yield put({ type: events.REQUEST });
    try {
      yield* callAndDispatchPayload(apiMethodsConst.ADD_FAVORITE_PROFESSIONAL_REQUEST, userId);
      yield put({ type: events.SUCCESS, payload: userId });
      yield* callAndDispatch(apiMethodsConst.FETCH_FAVORITE_PROFESSIONALS_REQUEST);
    } catch (error: any) {
      yield put({ type: events.FAILURE, payload: (error as AxiosError)?.response?.data });
    }
  }
}

export default function* sagaFavoritesProfessionals() {
  yield all([
    fork(watchFetchFavoriteProfessionals),
    fork(watchRemoveFavoriteProfessional),
    fork(watchPatchFavoriteProfessional),
    fork(watchFetchRecentProfessionals),
    fork(watchFetchRecommendedProfessionals),
  ]);
}
